import { useTheme } from "../ThemeProvider";
import { formatPrecioVentaEntero, parsePrecioVentaEntero } from "../../utils/moneyParse";

export function textoPrecioVistaPrevia(src = {}) {
  if (src.precio_web_consultar) return "A consultar";
  const raw = src.precio_venta ?? src.precio;
  const n = parsePrecioVentaEntero(raw);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `${formatPrecioVentaEntero(n)} €`;
}

/**
 * Cabecera compacta «Vista previa Ref: … · precio» (una sola línea, sin cambiar alto).
 */
export default function VistaPreviaRefPrecio({ referencia, prop, fontSize = 12, style, className = "" }) {
  const { theme } = useTheme();
  const src = prop || {};
  const ref = referencia ?? src.referencia ?? "—";
  const precioTxt = textoPrecioVistaPrevia(src);
  const green = theme.colors.accentGreen || "#22c55e";

  return (
    <span
      className={`truncate leading-tight ${className}`.trim()}
      style={{
        fontSize,
        color: theme.colors.textMuted,
        lineHeight: 1.2,
        ...style,
      }}
    >
      Vista previa Ref:{" "}
      <span style={{ color: "#ffffff", fontWeight: 700 }}>{ref}</span>
      {precioTxt ? (
        <>
          {" · "}
          <span style={{ color: green, fontWeight: 700 }}>{precioTxt}</span>
        </>
      ) : null}
    </span>
  );
}
